<app-irl-loading-screen [animated]="false"></app-irl-loading-screen>
<app-irl></app-irl>
